export function meterToPixel(lat: number, zoom: number, width_in_meters: number = 0.5) {
    const meters_per_pixel = 2 * Math.PI * 6378137 * Math.cos((Math.PI / 180) * lat) / (Math.pow(2, zoom + 8))
    return width_in_meters / meters_per_pixel
}
